import React from 'react';
import { shape, string, oneOf, node, number, oneOfType } from 'prop-types';
import { competitionPlaceUnionTypes, getCompetitionPlaceByName, getDurationUnit } from '@paddl/utils-js';
import { LogoCardWithText, Icons, MarkDownSection } from '../../../..';
import { DetailsWrapper } from '../../../Activity.styles';
export const HackathonRead = _ref => {
  let {
    data: {
      details: {
        event: {
          name: eventName
        },
        eventLocation: {
          originalText: eventLocation
        },
        organiser: {
          icon: organiserIcon,
          name: organiserName
        },
        eventDuration: {
          value: durationNumber,
          unit: durationUnit
        },
        competitionPlace,
        challengeDescription
      }
    },
    editButton
  } = _ref;
  const Award = Icons.award;
  return /*#__PURE__*/React.createElement(DetailsWrapper, null, editButton, /*#__PURE__*/React.createElement("h1", {
    className: "headline"
  }, eventName), /*#__PURE__*/React.createElement(LogoCardWithText, {
    avatarUrl: organiserIcon,
    title: organiserName,
    subtitle: eventLocation,
    isSubtitleShortened: true
  }), challengeDescription ? /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(MarkDownSection, {
    markDown: challengeDescription
  })) : null, competitionPlace && competitionPlace < 4 ? /*#__PURE__*/React.createElement("div", {
    className: "place",
    "data-test-id": "competition-place"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon"
  }, /*#__PURE__*/React.createElement(Award, null)), /*#__PURE__*/React.createElement("span", null, getCompetitionPlaceByName(competitionPlace))) : null, /*#__PURE__*/React.createElement("div", {
    className: "tags"
  }, "".concat(durationNumber, " ").concat(getDurationUnit(durationUnit, durationNumber))));
};
HackathonRead.propTypes = {
  data: shape({
    details: shape({
      event: shape({
        name: string
      }).isRequired,
      eventLocation: shape({
        originalText: string,
        shortText: string
      }).isRequired,
      organiser: shape({
        icon: string,
        name: string
      }).isRequired,
      eventDuration: shape({
        value: oneOfType([number, string]),
        unit: string
      }).isRequired,
      competitionPlace: oneOf(competitionPlaceUnionTypes),
      challengeDescription: string
    }).isRequired
  }).isRequired,
  editButton: node
};
HackathonRead.defaultProps = {
  editButton: undefined
};